import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCookieConsent } from 'react-cookie-manager';

const Footer: React.FC = () => {
    const { t } = useTranslation();
    const { showConsentBanner } = useCookieConsent();

    return (
        <footer className="border-t bg-white/80 backdrop-blur-sm">
            <div className="container mx-auto px-4 py-6 text-sm text-gray-600 flex flex-col sm:flex-row items-center justify-between gap-3">
                <div className="flex items-center gap-2">
                    <img src="/minifil-150.png" alt="Minifil" className="h-6 w-6" />
                    <span className="font-medium">{t('app.title')}</span>
                    <span className="text-gray-400">© {new Date().getFullYear()}</span>
                </div>
                <nav className="flex items-center gap-4">
                    <Link to="/terms" className="hover:text-gray-800 underline-offset-4 hover:underline">
                        {t('legal.terms.link', 'Terms of Service')}
                    </Link>
                    <Link to="/privacy" className="hover:text-gray-800 underline-offset-4 hover:underline">
                        {t('legal.privacy.link', 'Privacy Policy')}
                    </Link>
                    <button
                        type="button"
                        onClick={showConsentBanner}
                        className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-800 underline-offset-4 hover:underline"
                        aria-label={t('cookie.manageLink', 'Manage Cookie Preferences')}
                    >
                        <img src="/cookie.png" alt="Cookie" className="h-4 w-4" />
                        {t('cookie.manageLink', 'Manage Cookie Preferences')}
                    </button>
                </nav>
            </div>
        </footer>
    );
};

export default Footer;
